import React from 'react'
import { Box, Input, RadioInput, RadioLabel, Text, Textarea } from '@maui/elements'
import DatePicker from './DatePicker'
import { RequiredIndicator, InfoTooltip, FileAttachments, DropDownSelect } from '../common'
import { investigationDetailList } from '../../utils/helpers'
import { useFormContext } from './formUtils'

export default function AnalystInvestigation1() {
  const { state, dispatch } = useFormContext()

  return (
    <>
      <Box mb="spaceGapXLarge">
        <Text as="label" variant="heading5" fontSize='13px' mb="spaceGapMedium" display='block' htmlFor='titleInput'>
          Title <RequiredIndicator />
        </Text>
        <Input
          name='subject'
          id='titleInput'
          placeholder='Enter a title for your request...'
          value={state.subject.value}
          onChange={(e) => dispatch({ type: 'updateField', payload: e.target })}
          size='medium'
          width='100%'
          onBlur={(e) => dispatch({ type: 'updateField', payload: e.target })}
          borderColor={state.subject.error && 'colorFeedbackError'}
        />
      </Box>
      <Box mb="spaceGapXLarge">
        <Text as="label" variant="heading5" fontSize='13px' mb="spaceGapMedium" display='block' htmlFor='descriptionInput'>
          Description <RequiredIndicator />
        </Text>
        <Textarea
          id='descriptionInput'
          name='description'
          value={state.description.value}
          onChange={(e) => dispatch({ type: 'updateField', payload: e.target })}
          onBlur={(e) => dispatch({ type: 'updateField', payload: e.target })}
          height='104px'
          width='100%'
          placeholder='The following is intended to gather details regarding your needs. The more detail you provide the more quickly and accurately we will be able to action your analysis needs.'
          borderColor={state.description.error && 'colorFeedbackError'}
        />
      </Box>
      <FileAttachments onDropSuccess={arr => dispatch({ type: 'updateAttachments', payload: arr })} onFileRemoved={file => dispatch({ type: 'removeAttachment', payload: file })} />
      {/* <Box mb="spaceGapXLarge">
        <Box display="flex" mb="spaceGapMedium">
          <Text variant="heading5" fontSize='13px' as='label' htmlFor='sensitivity_level'>
            What level of sensitivity should we assign to your attachments? <RequiredIndicator />
          </Text>
          <InfoTooltip
            ml="spaceGapMedium"
            tooltip={<div>
              Mandiant&apos;s obligations:
              <br /><br />
              <strong>Red</strong>: No sharing with anyone outside this exchange.
              <br /><br />
              <strong>Amber</strong>: Only share with members of their own org.
              <br /><br />
              <strong>Green</strong>: Share with peers and partners.<br /><br />

              NOTE: Selecting “Red” may limit analysis options available, and thus limit efficacy of the request.
            </div>
            }
          />
        </Box>
        <Box
          display='flex'
          gridGap='8px'
          alignItems='center'
          mb="spaceGapXLarge"
        >
          <DropDownSelect name='sensitivity_level' id='sensitivity_level' menuLabel="Sensitivity options" list={sensitivityLevelList.map(({ label }) => label)} onClick={(item) => dispatch({ type: 'updateField', payload: { name: 'sensitivity_level', value: item } })} selectedItem={state.sensitivity_level.value}/>
        </Box>
      </Box> */}

      <Box mb="spaceGapXLarge">
        <Box display="flex" mb="spaceGapMedium">
          <Text variant="heading5" as='label' htmlFor='preferred_delivery_date'>
            Preferred Delivery Date <RequiredIndicator />
          </Text>
          <InfoTooltip
            ml="spaceGapMedium"
            tooltip="We may revise this date following discussion with you, to ensure adequate time available to provide you with a high-quality response."
          />
        </Box>
        <DatePicker state={state} dispatch={dispatch} />
      </Box>

      <Box mb="spaceGapXLarge">
        <Box display="flex" mb="spaceGapMedium">
          <Text variant="heading5" fontSize='13px' as='label' htmlFor='detail_amount'>
            Do You Want Speed, Depth, or Balance with this investigation? <RequiredIndicator />
          </Text>
          <InfoTooltip
            ml="spaceGapMedium"
            tooltip='We may revise this date following discussion with you, to ensure adequate time available to provide you with a high-quality response.'
          />
        </Box>
        <Box
          display='flex'
          gridGap='8px'
          alignItems='center'
          mb="spaceGapXLarge"
        >
          <DropDownSelect id='detail_amount'
            name='detail_amount' menuLabel="Detail amount options" list={investigationDetailList.map(({ label }) => label)} onClick={(item) => dispatch({ type: 'updateField', payload: { name: 'detail_amount', value: item } })} selectedItem={state.detail_amount.value} />
        </Box>
      </Box>

      <Box mb="spaceGapXLarge">
        <Box display="flex" mb="spaceGapMedium">
          <Text variant="heading5" fontSize='13px'>
            When do you want us to start working on your request? <RequiredIndicator />
          </Text>
        </Box>
        <Box
          display='flex'
          gridGap='8px'
          flexDirection='column'
          mb="spaceGapXLarge"
        >
          <Box display='flex' alignItems='center' margin='4px 0'>
            <RadioLabel mb='0' padding='0'>
              <RadioInput
                id='start-after-talk'
                mr='spaceGapSmall'
                name="work_start_choice"
                value="before"
                onChange={(e) => dispatch({ type: 'updateField', payload: e.target })}
                checked={state.work_start_choice.value === 'before'}
              />
            </RadioLabel>
            <Text ml='spaceGapMedium' variant='heading6' as="label" htmlFor="start-after-talk">
              Talk to me before consuming entitlements to start work
            </Text>
          </Box>
          <Box display='flex' alignItems='center' margin='4px 0'>
            <RadioLabel mb='0' padding='0'>
              <RadioInput
                id='start-immediately'
                mr='spaceGapSmall'
                name="work_start_choice"
                value="after"
                onChange={(e) => dispatch({ type: 'updateField', payload: e.target })}
                checked={state.work_start_choice.value === 'after'}
              />
            </RadioLabel>
            <Text ml='spaceGapMedium' variant='heading6' as="label" htmlFor="start-immediately">
              Consume investigation entitlements and begin work immediately
            </Text>
          </Box>
        </Box>
      </Box>

      <Box mb="spaceGapXLarge">
        <Text variant="body2" mb="spaceGapXLarge" color="colorTextDeemphasis">
          <RequiredIndicator /> Required fields
        </Text>
      </Box>
    </>
  )
}
